import { EDITOR_SCHEMA_VERSION } from "@workith/editor-schema";

export { EDITOR_SCHEMA_VERSION };

export const buildCollaborationUrl = (baseUrl: string, documentId: string): string => {
  const url = new URL(
    `${baseUrl.replace(/\/$/, "")}/collaboration/${encodeURIComponent(documentId)}`
  );
  url.searchParams.set("schemaVersion", EDITOR_SCHEMA_VERSION);
  return url.toString();
};
